<ng-container *transloco="let t">

  <div class="modal-header">

    <h2>{{header}}</h2>

    <!-- hack to fool ngbModal autofocus -->
    <input type="text" style="display:none" />

    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" aria-label="Close"
      (click)="activeModal.dismiss()">
      <span class="svg-icon svg-icon-2x">
        <close-x-svg-icon></close-x-svg-icon>
      </span>
    </div>
  </div>

  <div class="modal-body py-10 px-lg-17">
    <form #reoInfoForm="ngForm" class="form" novalidate id="reoInfoForm" name="reoInfoForm">
      <div class="me-n7 pe-7">
        <address #addressComponent [address]="address"></address>
        <div class="row align-items-end mb-8">
          @if (!isHidden('reo.typeOfProperty')) {
            <div class="col-md-6 fv-row">
              <label class="form-label mb-2" [ngClass]="{'required': isRequired('reo.typeOfProperty')}">{{getLabel('reo.typeOfProperty', t('wizard.reo.propertyType'))}}</label>
              <select name="propertyType" [ngClass]="{'is-invalid' : propertyType && propertyType.touched && propertyType.invalid}"
                [required]="isRequired('reo.typeOfProperty')"
                #propertyType="ngModel" class="form-select form-select-solid" [(ngModel)]="reo!.typeOfProperty"
                data-control="select2" data-hide-search="true" data-placeholder="Choose one">
                <option [ngValue]="null">{{ t('common.selectOne') }}</option>
                @for (propertyType of propertyTypes; track propertyType.value) {
                  <option #reoItem value="{{propertyType.value}}">{{propertyType.name}}</option>
                }
              </select>
              <div class="invalid-feedback">{{ t('wizard.reo.propertyTypeRequired') }}</div>
            </div>
          }
          @if (!isHidden('reo.marketValue')) {
            <div class="col-md-6 fv-row">
              <label class="form-label mb-2" [ngClass]="{'required': isRequired('reo.marketValue')}">{{getLabel('reo.marketValue', t('wizard.reo.propertyValue'))}}</label>
              <input class="form-control form-control-solid" mask="separator"  thousandSeparator="," prefix="$"
                [required]="isRequired('reo.marketValue')"
                (change)="onPropertyValueChanged()"
                [ngClass]="{'is-invalid' : propertyValue && propertyValue.touched && propertyValue.invalid}"
                #propertyValue="ngModel" [(ngModel)]="reo!.marketValue" placeholder="" name="propertyValue" />
              <div class="invalid-feedback">{{ t('wizard.reo.propertyValueRequired') }}</div>
            </div>
          }
        </div>
        <div class="row align-items-end mb-8">
          @if (!isHidden('reo.purchasePrice')) {
            <div class="col-md-6 fv-row">
              <label class="form-label mb-2" [ngClass]="{'required': isRequired('reo.purchasePrice')}">{{getLabel('reo.purchasePrice', t('wizard.reo.originalPurchasePrice'))}}</label>
              <input class="form-control form-control-solid" mask="separator" thousandSeparator="," prefix="$"
                [required]="isRequired('reo.purchasePrice')"
                (change)="onPurchasePriceChanged()"
                [ngClass]="{'is-invalid' : purchasePrice && purchasePrice.touched && purchasePrice.invalid}"
                #purchasePrice="ngModel" [(ngModel)]="reo!.purchasePrice" placeholder="" name="purchasePrice" />
            <div class="invalid-feedback">{{ t('wizard.reo.purchasePriceRequired') }}</div>
            </div>
          }
          @if (!isHidden('reo.dateAcquired')) {
            <div class="col-md-6 fv-row">
              <label class="form-label mb-2" [ngClass]="{'required': isRequired('reo.dateAcquired')}">{{getLabel('reo.dateAcquired', t('wizard.reo.dateAcquired'))}}</label>
              <div class="position-relative d-flex align-items-center">
                <input class="form-control form-control-solid" matInput mask="00/00/0000" [showMaskTyped]="true" autocomplete="off"
                  [specialCharacters]="[ '/' ]" inputmode="numeric" [dropSpecialCharacters]="false" datePicker #dateAcquired="ngModel"
                  [(ngModel)]="reo.dateAcquired" placeholder="" name="dateAcquired" ngControl="dateAcquired" id="dateAcquired"
                  [ngClass]="{'is-invalid' : dateAcquired && dateAcquired.touched && dateAcquired.invalid}"
                  [required]="isRequired('reo.dateAcquired')"/>
                <div class="invalid-feedback">{{ t('wizard.reo.dateAcquiredRequired') }}</div>
              </div>
            </div>
          }
        </div>
        <div class="row align-items-end mb-8">
          @if (!isHidden('reo.currentUsageType')) {
            <div class="col-md-4 fv-row">
              <label class="form-label mb-2" [ngClass]="{'required': isRequired('reo.currentUsageType')}">{{getLabel('reo.currentUsageType', t('wizard.reo.currentUsage'))}}</label>
              <select name="currentUsageType" [ngClass]="{'is-invalid' : currentUsageType && currentUsageType.touched && currentUsageType.invalid}"
                [required]="isRequired('reo.currentUsageType')"
                #currentUsageType="ngModel" class="form-select form-select-solid" [(ngModel)]="reo!.currentUsageType"
                data-control="select2" data-hide-search="true" data-placeholder="Choose one">
              <option [ngValue]="null">{{ t('common.selectOne') }}</option>
              @for (usageType of usageTypes; track usageType.value) {
                <option #reoItem value="{{usageType.value}}">{{usageType.name}}</option>
              }
            </select>
            <div class="invalid-feedback">{{ t('wizard.reo.fieldRequired') }}</div>
            </div>
          }

          <div class="col-md-4 fv-row">
            <label class="form-label mb-2 required">{{ t('wizard.reo.planOnSelling') }}</label>
            <select
              name="dispositionStatus"
              id="dispositionStatus"
              [ngClass]="{'is-invalid' : willPropertyBeSoldValue && willPropertyBeSoldValue.touched && willPropertyBeSoldValue.invalid}"
              [required]="true"
              #willPropertyBeSoldValue="ngModel" class="form-select form-select-solid"
              [(ngModel)]="willPropertyBeSold"
              (ngModelChange)="onPropertyWillBeSoldChanged()"
              data-control="select2" data-hide-search="true" data-placeholder="Choose one">
            <option value="no">{{ t('common.no') }}</option>
            <option value="yes">{{ t('common.yes') }}</option>
          </select>
          <div class="invalid-feedback">{{ t('wizard.reo.fieldRequired') }}</div>
          </div>

          @if (!isHidden('reo.intendedUsageType') && willPropertyBeSold === 'no') {
            <div class="col-md-4 fv-row">
              <label class="form-label mb-2" [ngClass]="{'required': isRequired('reo.intendedUsageType')}">{{getLabel('reo.intendedUsageType', t('wizard.reo.intendedUsage'))}}</label>
              <select name="intendedUsageType" [ngClass]="{'is-invalid' : intendedUsageType && intendedUsageType.touched && intendedUsageType.invalid}"
                [required]="isRequired('reo.intendedUsageType')"
                #intendedUsageType="ngModel" class="form-select form-select-solid" [(ngModel)]="reo!.intendedUsageType"
                data-control="select2" data-hide-search="true" data-placeholder="Choose one">
              <option [ngValue]="null">{{ t('common.selectOne') }}</option>
              @for (usageType of usageTypes; track usageType.value) {
                <option #reoItem value="{{usageType.value}}">{{usageType.name}}</option>
              }
            </select>
            <div class="invalid-feedback">{{ t('wizard.reo.fieldRequired') }}</div>
            </div>
          }
        </div>
        @if (!isHidden('reo.amountOfMortgage')) {
          <div class="row mb-8">
            <div class="col-md-12 fv-row">
              <reo-liens #reoLiens [mortgage]="mortgage" [reo]="reo"
                [label]="getLabel('reo.amountOfMortgage', t('wizard.reo.currentBalance'))"
                [required]="isRequired('reo.amountOfMortgage')">
              </reo-liens>
            </div>
          </div>
        }
        <div class="row align-items-end mb-8">
          @if (!isHidden('reo.mortgagePayment')) {
            <div class="col-md-4 fv-row">
              <label class="form-label mb-2" [ngClass]="{'required': isRequired('reo.mortgagePayment')}">{{getLabel('reo.mortgagePayment', t('wizard.reo.monthlyPayment'))}}</label>
              <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
                [ngClass]="{'is-invalid' : mortgagePayment && mortgagePayment.touched && mortgagePayment.invalid}"
                [required]="isRequired('reo.mortgagePayment')"
                #mortgagePayment="ngModel" [(ngModel)]="reo!.mortgagePayment" placeholder="" name="mortgagePayment" />
              <div class="invalid-feedback">{{ t('wizard.reo.fieldRequired') }}</div>
            </div>
          }
          @if (!isHidden('reo.monthlyMiscExpenses')) {
            <div class="col-md-4 fv-row">
              <label class="form-label mb-2 me-2" [ngClass]="{'required': isRequired('reo.monthlyMiscExpenses')}">{{getLabel('reo.monthlyMiscExpenses', t('wizard.reo.insuranceHoaTax'))}}</label>
              <button class="icon-button"
                [title]="t('wizard.reo.monthlyExpenseBreakdown')"
                #popover="ngbPopover"
                data-bs-toggle="tooltip"
                [ngbPopover]="popoverContent"
                popoverClass="custom-popover"
                [popoverTitle]="t('wizard.reo.monthlyExpenseBreakdown')"
                [autoClose]="'outside'"
                triggers="manual">
                <i class="fas fa-calculator text-primary" (click)="onOpenReoExpenseBreakdownClicked()"></i>
              </button>
              <ng-template #popoverContent let-reo="reo">
                <reo-expense-breakdown
                  #reoExpenseBreakdown
                  [reo]="reo"
                  (cancelClicked)="popover.close()"
                  (okClicked)="onOkClickedOnReoBreakdownPopover($event); popover.close();"
                ></reo-expense-breakdown>
              </ng-template>
              <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
                [ngClass]="{'is-invalid' : monthlyMiscExpenses && monthlyMiscExpenses.touched && monthlyMiscExpenses.invalid}"
                [required]="isRequired('reo.monthlyMiscExpenses')"
                #monthlyMiscExpenses="ngModel" [(ngModel)]="reo['totalExpenses']"
                [disabled]="isExpensesBrokenDown"
                (blur)="onTotalExpensesChanged()"
                placeholder="" name="monthlyMiscExpenses" />
              <div class="invalid-feedback">{{ t('wizard.reo.fieldRequired') }}</div>
            </div>
          }
        </div>
        <div class="row align-items-end mb-8">
          @if (!isHidden('reo.grossRentalIncome')) {
            <div class="col-md-4 fv-row">
              <label class="form-label mb-2" [ngClass]="{'required': isRequired('reo.grossRentalIncome')}">{{getLabel('reo.grossRentalIncome', t('wizard.reo.grossRentalIncome'))}}</label>
              <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
                [ngClass]="{'is-invalid' : grossRentalIncome && grossRentalIncome.touched && grossRentalIncome.invalid}"
                [required]="isRequired('reo.grossRentalIncome')"
                #grossRentalIncome="ngModel" [(ngModel)]="reo!.grossRentalIncome" placeholder="" name="grossRentalIncome" />
              <div class="invalid-feedback">{{ t('wizard.reo.fieldRequired') }}</div>
            </div>
          }
        </div>
        @if (!inCoApplyFlow) {
          <div class="row mb-5">
            <div class="col-md-12 fv-row">
              <label class="required form-label mb-2">{{ t('wizard.reo.whoOwnsRealEstate') }}</label>
              <div class="pl-20">
                <multi-checkbox-picker [possibleChoices]="possibleBorrowers" [selectedItems]="selectedBorrowers"  [disabledChoices]="disabledBorrowers"></multi-checkbox-picker>
              </div>
            </div>
          </div>
        }
      </div>
    </form>
  </div>

  <div class="modal-footer flex-center">
    <button type="button" class="btn btn-white me-3" (click)="activeModal.dismiss()">{{ t('common.cancel') }}</button>
    <button type="button" class="btn btn-primary" (click)="onSaveClicked()">{{ t('common.ok') }}</button>
  </div>

</ng-container>
